import type React from "react"

import { useFormatDecimal } from "@/formatters"
import { HStack } from "@/nzds/layout"

import { Divider, Typography } from "@mui/material"

import { DataGridLegendItem } from "../data-grid-legend-item"
import type { DataGridLegendProps } from "./data-grid-legend.types"

export const DataGridLegend: React.FC<DataGridLegendProps> = ({
  children,
  itemCount,
  itemLabel,
}) => {
  const { formatDecimal: formatDecimalToInteger } = useFormatDecimal({
    precision: 0,
  })

  return (
    <Typography component="div" variant="body2">
      <HStack
        divider={
          <Divider
            sx={{ borderColor: "text.secondary" }}
            flexItem
            orientation="vertical"
          />
        }
        sx={{ alignItems: "center", gap: 3 }}
      >
        <DataGridLegendItem
          data-testid="site-count"
          label={itemLabel}
          value={formatDecimalToInteger(itemCount)}
        />

        {children ? (
          <HStack
            divider={<Divider flexItem orientation="vertical" />}
            sx={{ alignItems: "center", gap: 1 }}
          >
            {children}
          </HStack>
        ) : null}
      </HStack>
    </Typography>
  )
}
